import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { IAboutUsInitialState } from "@/types/aboutus.types";
import { getAllActiveFAQ } from "@/services/aboutUs.services";
import { getAllActiveBlogs, getBlogByBlogURL } from "@/services/blog.services";

export const getBlogByID = createAsyncThunk(
  "/Blog/FindByIDBlog",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Blog/FindByIDBlog`,
        { ID }
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Blog:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

const initialState: IAboutUsInitialState = {
  loading: false,
  error: "",
  AboutUsDetails: {},
  BlogDetails: {},
  BlogList: [],
  FAQList: [],
};

const aboutUsSlice = createSlice({
  name: "aboutUs",
  initialState,
  reducers: {
    clearBlogDetails: (state) => {
      state.BlogDetails = initialState.BlogDetails;
    },
    setBlogList: (state, action) => {
      state.BlogList = action.payload;
    },
    setFAQList: (state, action) => {
      state.FAQList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveBlogs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveBlogs.fulfilled, (state, action) => {
      state.loading = false;
      state.BlogList = action.payload;
      state.error = "";
    });
    builder.addCase(getAllActiveBlogs.rejected, (state, action) => {
      state.loading = false;
      state.BlogList = initialState.BlogList;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getBlogByID.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBlogByID.fulfilled, (state, action) => {
      state.loading = false;
      state.BlogDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getBlogByID.rejected, (state, action) => {
      state.loading = false;
      state.BlogDetails = initialState.BlogDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveFAQ.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveFAQ.fulfilled, (state, action) => {
      state.loading = false;
      state.FAQList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveFAQ.rejected, (state, action) => {
      state.loading = false;
      state.FAQList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getBlogByBlogURL.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBlogByBlogURL.fulfilled, (state, action) => {
      state.loading = false;
      state.BlogDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getBlogByBlogURL.rejected, (state, action) => {
      state.loading = false;
      state.BlogDetails = initialState.BlogDetails;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default aboutUsSlice.reducer;
export const { clearBlogDetails, setBlogList, setFAQList } = aboutUsSlice.actions;
